import type { StepExperimentProps } from './hooks/useStepExperiment';
import { useStepExperiment } from './hooks/useStepExperiment';

/**
 * Renders one step of a step experiment: an independently-bucketed experiment scoped to a step's
 * UI/content that runs in tandem with the active flow experiment. Swap the step's control-flow row
 * in `PageBody` one-for-one to this component — flow-variant (`flowId`-gated) rows stay above it.
 *
 * See docs/front-end/pages/startAPetitionV2/experiments/index.md — Step experiments.
 */
export function StepExperiment(props: StepExperimentProps) {
	const {
		data: { Component },
	} = useStepExperiment(props);

	return <Component />;
}
